import { attr } from 'redux-orm';
import InternalBaseModel from './InternalBaseModel';

export default class Form extends InternalBaseModel {
  static modelName = 'Form';
  static fields = {
    formId: attr()
  };
  static get options() {
    return {
      idAttribute: 'formId'
    };
  }
}
